import { createI18n } from 'vue-i18n';
import hr from "./hr.js";
import en from "./en.js";
import sl from "./sl.js";

const messages = {
    hr: hr,
    en: en,
    sl: sl
};

const i18n = createI18n(
    {
        legacy: false,
        locale: localStorage.getItem("selected_language") || 'hr',
        fallbackLocale: localStorage.getItem("selected_language") || 'hr',
        messages
    }
);

export default i18n;